import { Box, Theme, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import _ from "lodash";
import * as React from "react";

import { useState } from "react";

import { Add } from "@material-ui/icons";

import EditButton from "../../../components/Table/EditButton";
import { EditTagsModal } from "../BulkEdit/EditTagsModal";

const useStyles = makeStyles((theme: Theme) => ({
  eventTag: {
    padding: "2px 10px",
    backgroundColor: "rgba(38, 50, 56, 0.08)",
    borderRadius: "10px",
    fontSize: "0.8rem",
    verticalAlign: "middle",
    display: "inline-block",
  },
  logoContainer: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    border: "1px solid rgba(63, 81, 181, 0.1)",
  },
  wrapper: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    margin: theme.spacing(-2),

    "&:hover $editButton": {
      display: "block",
    },
  },

  editButton: {},
}));

interface TagsCellProps {
  allTags: Record<string, true>;
  activeTags: Record<string, true>;
  onSave: (tags: Record<string, true>) => void;
}

export function TagsCell({ activeTags, allTags, onSave }: TagsCellProps) {
  const classes = useStyles();

  const [isEditing, setIsEditing] = useState<boolean>(false);

  function handleClose() {
    setIsEditing(false);
  }

  function handleSave(tags: Record<string, true>) {
    setIsEditing(false);
    onSave(tags);
    // Make a request to save the tags and refresh the event definitions and call handleClose()
  }

  return (
    <>
      {isEditing && (
        <div onClick={(e) => e.stopPropagation()}>
          <EditTagsModal
            numEvents={1}
            prevAllTags={allTags}
            prevSetTags={activeTags}
            onClose={handleClose}
            onSave={handleSave}
          />
        </div>
      )}
      <Box className={clsx(classes.wrapper)}>
        {_.size(activeTags) > 0 && (
          <>
            <span className="truncate">
              {_(activeTags)
                .keys()
                .orderBy((tag) => _.lowerCase(tag))
                .map((tag, i) => (
                  <span key={tag}>
                    <div className={clsx(classes.eventTag)} key={tag}>
                      {tag}
                    </div>
                    {i < _.size(activeTags) - 1 && " "}
                  </span>
                ))
                .value()}
            </span>
            <EditButton
              className={clsx(classes.editButton)}
              onClick={(e) => {
                // we stop propagation of event to prevent that
                // clicks on buttons trigger clicks on the row
                e.stopPropagation();
                setIsEditing(true);
              }}
            />
          </>
        )}
        {_.size(activeTags) === 0 && (
          <Tooltip placement="top" title="Add Tags">
            <Box
              component="button"
              className={clsx(classes.logoContainer)}
              style={{
                transform: `translateX(-4px)`,
              }}
              onClick={(e) => {
                // we stop propagation of event to prevent that
                // clicks on buttons trigger clicks on the row
                e.stopPropagation();
                setIsEditing(true);
              }}
            >
              <Add width={20} height={20} />
            </Box>
          </Tooltip>
        )}
      </Box>
    </>
  );
}
